"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.savePrivateInfoHandler = exports.EditProfilePrivateInfo = exports.ProfilePrivateInfo = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var semantic_ui_react_1 = require("semantic-ui-react");
var i18n_1 = __importDefault(require("../i18n"));
var api_1 = require("../api");
var util_1 = require("../util");
var ProfileIcon_1 = require("./ProfileIcon");
var sentry_1 = require("../sentry");
var ShowProfilePrivateInfo_1 = require("./ShowProfilePrivateInfo");
var withState_1 = require("../hocs/withState");
var connect = (0, withState_1.withState)()([
    "requestEditProfilePrivateInfo",
    "editProfilePrivateInfo",
    "setEditProfilePrivateInfo",
    "tempPrivateMemo",
    "setTempPrivateMemo",
    "tempPrivateTags",
    "setTempPrivateTags",
    "profilePrivateInfoSaving",
    "setProfilePrivateInfoSaving",
    "applyProfilePrivateInfo",
]);
var profilePrivateInfoPropsEqual = function (prev, next) {
    if (prev.requestEditProfilePrivateInfo !== next.requestEditProfilePrivateInfo)
        return false;
    if (prev.editProfilePrivateInfo !== next.editProfilePrivateInfo)
        return false;
    if (prev.profilePrivateInfoSaving !== next.profilePrivateInfoSaving)
        return false;
    if (prev.user.note !== next.user.note)
        return false;
    if (!(0, util_1.isProfilePrivateInfoEqual)(prev.user.profile, next.user.profile))
        return false;
    if (next.editProfilePrivateInfo === next.user.id) {
        if (!(0, util_1.isTempProfilePrivateInfoEqual)(prev, next))
            return false;
    }
    return true;
};
exports.ProfilePrivateInfo = connect.memoFC(function (state) {
    return state.editProfilePrivateInfo === state.user.id ? ((0, jsx_runtime_1.jsx)(exports.EditProfilePrivateInfo, __assign({}, state))) : ((0, jsx_runtime_1.jsx)(ShowProfilePrivateInfo_1.ShowProfilePrivateInfo, { user: state.user }));
}, profilePrivateInfoPropsEqual);
var EditProfilePrivateInfo = function (state) {
    var changed = privateInfoChanged(state);
    return ((0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Form, { onSubmit: function (e) { return e.preventDefault(); }, loading: state.profilePrivateInfoSaving, children: [(0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Form.Field, { children: [(0, jsx_runtime_1.jsxs)("label", { children: [(0, jsx_runtime_1.jsx)(ProfileIcon_1.ProfileIcon, { iconFor: "privateMemo" }), i18n_1.default.privateMemo] }), (0, jsx_runtime_1.jsx)(semantic_ui_react_1.TextArea, { defaultValue: state.tempPrivateMemo || "", onBlur: function (e) {
                            return state.setTempPrivateMemo(e.currentTarget.value);
                        } })] }), (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Button, { onClick: (0, exports.savePrivateInfoHandler)(state), color: "red", children: i18n_1.default.update }), (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Button, { type: "button", onClick: function () {
                    // eslint-disable-next-line no-restricted-globals
                    return (!changed || confirm(i18n_1.default.cancelConfirm)) && state.setEditProfilePrivateInfo(undefined);
                }, children: i18n_1.default.cancel })] }));
};
exports.EditProfilePrivateInfo = EditProfilePrivateInfo;
var savePrivateInfoHandler = function (state) { return function () { return __awaiter(void 0, void 0, void 0, function () {
    var res, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, 4, 5]);
                state.setProfilePrivateInfoSaving(true);
                if (!privateInfoChanged(state)) return [3 /*break*/, 2];
                return [4 /*yield*/, (0, api_1.saveProfilePrivateMemo)(state)];
            case 1:
                res = _a.sent();
                state.applyProfilePrivateInfo(res === null || res === void 0 ? void 0 : res.isSynced);
                _a.label = 2;
            case 2:
                state.setEditProfilePrivateInfo(undefined);
                return [3 /*break*/, 5];
            case 3:
                e_1 = _a.sent();
                (0, sentry_1.captureException)(e_1);
                alert("".concat(i18n_1.default.profile, "\n").concat(e_1));
                return [3 /*break*/, 5];
            case 4:
                state.setProfilePrivateInfoSaving(false);
                return [7 /*endfinally*/];
            case 5: return [2 /*return*/];
        }
    });
}); }; };
exports.savePrivateInfoHandler = savePrivateInfoHandler;
var privateInfoChanged = function (state) {
    return state.user.profile
        ? (0, util_1.valueToStr)(state.user.profile.privateMemo) !== (0, util_1.valueToStr)(state.tempPrivateMemo)
        : (0, util_1.valueToStr)(state.tempPrivateMemo).length;
};
